export enum IvrTab {
  scenario = 'settings/switchboard/ivr/script',
  audio = 'settings/switchboard/ivr/audio',
}
export class IvrConst {
  static displayIvrColumns = () => {
    return [
      {
        title: 'Tên kịch bản',
        key: 'NAME',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Đầu số',
        key: 'RULE',
        display: true,
        allowSort: false,
        classes: '',
      },
    ];
  };
  static displayAudioColumns = () => {
    return [
      {
        title: 'Tên file ghi âm',
        key: 'file_name',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Mô tả',
        key: 'display_description',
        display: true,
        allowSort: false,
        classes: '',
      },
    ];
  };
  static displayFileNameColumns = audio => {
    return `<span class="">${audio.id} - ${audio.file_name}</span>`;
  };
  static displayAudioDescriptionColumns = audio => {
    if (!audio.description || audio.description == 'undefined') {
      return '';
    }
    return audio.description;
  };
}

export function getCurrentTab(url) {
  let tab = '';
  Object.keys(IvrTab).forEach(s => {
    if (url.includes(IvrTab[s])) {
      tab = IvrTab[s];
    }
  });
  return tab;
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/switchboard/ivr/ivr.const.ts